module.exports = __webpack_public_path__ + "static/media/47-web-or-mls-DSC06952.2628146f.jpg";